// removed by extract-text-webpack-plugin
module.exports = {"Showcase":"Showcase__Showcase__1CxsD","mainGroup":"Showcase__mainGroup__1DZAJ","fadeInUp":"Showcase__fadeInUp__7Xbyb","heroImageContainer":"Showcase__heroImageContainer__3ROnl","heroImage":"Showcase__heroImage__2vSZb","Action":"Showcase__Action__fMl1i","fadeIn":"Showcase__fadeIn__2Rq9L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/Showcase/Showcase.css
// module id = 288
// module chunks = 0